var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 18,
    fill: "#2DAE32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.495 23.7139C32.7016 23.2954 33.2984 23.2954 33.505 23.7139L36.179 29.1321C36.261 29.2983 36.4196 29.4135 36.603 29.4401L42.5823 30.309C43.0441 30.3761 43.2286 30.9437 42.8944 31.2695L38.5677 35.4869C38.435 35.6163 38.3744 35.8027 38.4058 35.9854L39.4271 41.9404C39.506 42.4005 39.0232 42.7513 38.6101 42.5341L33.2621 39.7225C33.098 39.6362 32.902 39.6362 32.738 39.7225L27.39 42.5341C26.9768 42.7513 26.494 42.4005 26.5729 41.9404L27.5943 35.9854C27.6256 35.8027 27.565 35.6163 27.4323 35.4869L23.1057 31.2695C22.7714 30.9437 22.9559 30.3761 23.4178 30.309L29.397 29.4401C29.5804 29.4135 29.739 29.2983 29.821 29.1321L32.495 23.7139Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.b868c5bf0e8f0f3622764d85658a6afb.svg";
export { ForwardRef as ReactComponent };